import React, { useEffect, useState } from "react";
import "./DeviceDiagnostics.css";
import { Fragment } from "react";
import { format } from "date-fns";
import { Box } from "@mui/material";
import AppButton from "../../Common/Button/Button";
import DataTable from "../../Common/DataTable/DataTable";
import { commonHeaders } from "./DeviceDiagnosticsConstants";
import { formatTableHeader } from "../../../utils/general";

const DisplayDeviceDiagnosticsData = ({
    deviceCategory,
    deviceDiagnosticsData,
    setDialog,
    setDialogContents
}) => {
    const [headers, setHeaders] = useState({})

    useEffect(() => {
        const dataHeaders = {};
        //building a unique list of headers after going through each record in the dataset
        deviceDiagnosticsData?.map(d => {
            Object?.keys(d?.payload)?.forEach(h => {
                if (!dataHeaders?.hasOwnProperty(h)) {
                    dataHeaders[h] = { header: formatTableHeader(d?.payload[h]?.header !== "" ? d?.payload[h]?.header : h), desc: d?.payload[h]?.desc }
                }
            })
        })
        delete dataHeaders?.ty
        delete dataHeaders?.ts
        delete dataHeaders?.st
        delete dataHeaders?.mo
        setHeaders({
            ...commonHeaders,
            ...dataHeaders,
            ...(() => {
                //not taking any fixed headers for AC
                // if (deviceCategory === 'AC') {
                //     return { ...ACDiagnosticHeaders }
                // }
                return {}
            })(),
            actions: { header: "Actions", desc: "" }
        })
    }, [deviceDiagnosticsData])

    const diagnosticColumns = Object.keys(headers).map((key, ind) => ({
        key,
        label: headers[key]?.header,
        minWidth: key === "actions" ? 110 : 180,
        justifyContent: ind === Object.keys(headers)?.length - 1 ? "flex-end" : "flex-start",
        headerCellSx: {
            maxWidth: 300,
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        render: (value, row) => {
            if (key === "serialNumber") {
                return <Box>{row.serialNumber}</Box>;
            }

            if (key === "actions") {
                return (
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <AppButton
                            variant="primary"
                            size="small"
                            onClick={() => {
                                setDialogContents({ title: "Diagnostic Details", data: row.raw });
                                setDialog(true);
                            }}
                        >
                            View
                        </AppButton>
                    </Box>
                );
            }

            if (key === "ts" || key === "st") {
                const payloadValue = row?.payload?.[key]?.value;
                return String(payloadValue || "").length > 0 ? (
                    <Box>
                        {format(new Date(Number(payloadValue) * 1000), "dd MMM yyyy, hh:mm a")}
                    </Box>
                ) : (
                    ""
                );
            }

            const payloadEntry = row?.payload?.[key];
            const displayValue = payloadEntry?.value ?? "-";
            return (
                <Box className={String(payloadEntry || "").length > 200 ? "breakWord" : ""}>
                    {displayValue}
                </Box>
            );
        },
    }));

    const diagnosticRows = Array.isArray(deviceDiagnosticsData)
        ? deviceDiagnosticsData.map((element, index) => ({
            rowId: `${element?.payload?.ts?.value || element?.payload?.st?.value || "diag"}-${index}`,
            raw: element,
            payload: element?.payload || {},
            serialNumber: index + 1,
        }))
        : [];

    return (
        <Fragment>
            {
                deviceCategory && deviceCategory!=="" && deviceDiagnosticsData &&
                <DataTable
                    columns={diagnosticColumns}
                    data={diagnosticRows}
                    rowKey="rowId"
                    minWidth="100%"
                    maxHeight={400}
                    striped={false}
                    hoverEffect={false}
                    tableContainerSx={{ boxShadow: "none", borderRadius: 0 }}
                    sx={{ mb: 2 }}
                    msgForDisplay="No Data found"
                />
            }
        </Fragment>
    );
};
export default DisplayDeviceDiagnosticsData